import type {
  ClientMenuConfigListApiResponse,
  ClientMenuConfigNode,
  ClientMenuConfigQuery,
  ClientMenuConfigSaveParams,
  ClientMenuConfigSaveResult,
} from './types/client-menu-config'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export const clientMenuConfigApi = defineApi('operation', ({ prefix }) => {
  function list(params: ClientMenuConfigQuery = {}) {
    return requestClient
      .post<ClientMenuConfigListApiResponse>(prefix('menu/query'), {
        keyword: params.keyword,
        type: params.type,
      })
      .then((data) => ({
        list: data.menuTree.map(function mapNode(node): ClientMenuConfigNode {
          return {
            children: node.children?.map(mapNode),
            id: node.id,
            permissionFrontRoute: node.permissionFrontRoute,
            permissionLevel: node.permissionLevel,
            permissionMark: node.permissionMark,
            permissionName: node.permissionName,
            permissionParentId: node.permissionParentId,
            permissionRoute: node.permissionRoute,
            sort: node.sort,
            type: node.type,
            updateTime: node.updateTime,
          }
        }),
      }))
  }

  function getDetail(id: number) {
    return requestClient
      .get<ClientMenuConfigNode>(prefix(`menu/${id}`))
      .then((data) => ({
        id: data.id,
        permissionFrontRoute: data.permissionFrontRoute,
        permissionLevel: data.permissionLevel,
        permissionMark: data.permissionMark,
        permissionName: data.permissionName,
        permissionParentId: data.permissionParentId,
        permissionRoute: data.permissionRoute,
        sort: data.sort,
        type: data.type,
        updateTime: data.updateTime,
      }))
  }

  function save(params: ClientMenuConfigSaveParams) {
    return requestClient
      .post<ClientMenuConfigSaveResult>(prefix('menu/save'), {
        id: params.id,
        permissionDimension: 'web',
        permissionFrontRoute: params.permissionFrontRoute,
        permissionMark: params.permissionMark,
        permissionName: params.permissionName,
        permissionParentId: params.permissionParentId,
        permissionRoute: params.permissionRoute,
        sort: params.sort,
        type: params.type,
      })
      .then((data) => ({ id: data.id }))
  }

  return {
    getDetail,
    list,
    save,
  }
})
